/* React Libraries */
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';

import utilStorage from '../services/util-storage';
import { defaultLang, languages } from '@src/i18n';

const useActiveLanguage = (useTimeStamp: boolean = false) => {
  const { i18n } = useTranslation();
  const [activeLang, setActiveLang] = useState<string>(defaultLang);
  const { storedLanguageCode, languageSetTime } =
    utilStorage.readLocalLanguageData();

  useEffect(() => {
    const lang =
      typeof i18n.language === 'string'
        ? i18n.language.toLocaleLowerCase()
        : defaultLang;

    if (storedLanguageCode !== i18n.language) {
      utilStorage.setLocalLanguageSelector({
        storedLanguageCode:
          languages[lang] && languages[lang].enabled ? lang : defaultLang,
        languageSetTime: useTimeStamp
          ? Math.floor(Date.now() / 1000)
          : languageSetTime,
      });
      setActiveLang(i18n.language);
    }
  }, [i18n.language, activeLang]);

  return { activeLang, storedLanguageCode, languageSetTime };
};

export default useActiveLanguage;
